import React from 'react'
import classes from './Menus.scss'
import {history} from 'main'

// const MenuConfig = [
//   {
//     title: 'Merchandize Analysis',
//     menus: [
//       {
//         title: 'Store Sales Comparison',
//         route: '/detailed-analytics'
//       },
//       {
//         title: 'Category/Product Sales',
//         route: '/product-wise-sales-analytics'
//       },
//       {
//         title: 'Frequency Analysis',
//         route: '/all-product-analytics'
//       },
//       {
//         title: 'Basket Analysis',
//         route: '/basket-analysis'
//       },
//       {
//         title: 'Product Sales Forecast',
//         route: '/product-sales-forecast'
//       }
//     ]
//   },
//   {
//     title: 'Customer Analysis',
//     menus: [
//       {
//         title: 'Lifecycle Management',
//         route: '/purchases-clustering-analytics'
//       },
//       {
//         title: 'Feedback',
//         route: '/form-response-analytics'
//       },
//       {
//         title: 'Frequency Analysis',
//         route: '/customer-purchase'
//       }
//     ]
//   },
//   {
//     title: 'Store Operations',
//     menus: [
//       {
//         title: 'Customer Details',
//         route: '/customer-details'
//       },
//       {
//         title: 'Store Sales Comparison',
//         route: '/detailed-analytics'
//       },
//       {
//         title: 'Category/Product Sales',
//         route: '/category-analytics'
//       }
//     ]
//   },
//   {
//     title: 'Campaign Analysis',
//     menus: [
//       {
//         title: 'Campaign Sales Analysis',
//         route: '/sales-analytics'
//       },
//       {
//         title: 'Campaign Details',
//         route: '/home'
//       }
//     ]
//   }
// ]
export default class Menus extends React.Component {
  constructor(props) {
    super(props)
    // this.state = {
    //   selectedMenu: this.props.menuItems[0],
    //   selectedSubMenu: this.props.menuItems[0].menus[0]
    // }
  }

    mainMenuView(menuItems, onChangeMenu, selectedMenu, selectedSubMenu) {
    return (<div className={classes.mainMenuContainer}>
      {menuItems.map(mainMenu =>
        <div
          className={mainMenu.title === selectedMenu.title ? `${classes.mainMenuItem} ${classes.active}` : classes.mainMenuItem}
          onClick={() => {
            onChangeMenu(mainMenu.menus[0].route, {
              selectedMenu: mainMenu,
              selectedSubMenu: mainMenu.menus[0]
            })
          }}
        >
          {mainMenu.title}
        </div>)}
    </div>)
  }

  subMenuView(menuItems, onChangeMenu, selectedMenu, selectedSubMenu) {
    return (<div className={classes.subMenuContainer}>
      {selectedMenu.menus.map(subMenu =>
        <div
          className={subMenu.title === selectedSubMenu.title ? `${classes.subMenuItem} ${classes.active}` : classes.subMenuItem}
          onClick={() => {
            onChangeMenu(subMenu.route, {selectedMenu: selectedMenu, selectedSubMenu: subMenu})
          }}>
          {subMenu.title}
        </div>)}
    </div>)
  }

  render() {
    const {showTopMenu, menuItems, routePath, onChangeMenu, selectedMenu, selectedSubMenu} = this.props
    return (<div className={classes.container}>
      {showTopMenu ? this.mainMenuView(menuItems, onChangeMenu, selectedMenu, selectedSubMenu) : <div></div>}
      {showTopMenu ? this.subMenuView(menuItems, onChangeMenu, selectedMenu, selectedSubMenu) : <div></div>}
    </div>)
  }
}



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/Menus.js